









































































































































































































































import storeHelper from "../../store/store-helper";
import { ContentItemFilterField, ContentItemFilterFieldOption } from "../../types/filter/contentItemFilterField";
import Vue from "vue";
import { Collection } from "../../types/collection/collection";
import { SystemFilters } from "@/enums";
import VueI18n from "vue-i18n";
import { SearchScope } from "../../types/portal";
import { Portal } from "@infoland/iprova-api/lib/types/portal";
import { Constants } from "@/constants";
import Utils from "@/utils";

type FilterFieldTreeViewOption = ContentItemFilterFieldOption & {
    treeItemId: string;
    parentId: string;
    parentTreecode: string[];
    hasActiveChild: boolean;
};

export default Vue.extend({
    name: "BrowseFilterNavigationDrawer",
    components: {},
    props: {
        showScope: Boolean,
        showFilterPanelProp: Boolean,
        contentItemsLoading: Boolean,
        filterFieldShouldReload: Boolean,
        scope: { default: "portal" as SearchScope },
        portal: Object as () => Portal,
        currentPortalDisabled: Boolean,
        hoverCurrentPortalDisabledMessage: String,
        collections: Array as () => Collection[],
        selectedCollectionId: { type: Number, required: true }
    },
    data: function () {
        return {
            showFilterPanel: this.showFilterPanelProp,
            showFilterTypeOptionPanel: true,
            showFilterOptionsDrawer: false,

            expandedCollectionIds: [] as number[],
            componentMounted: false,
            filterFieldStatus: {} as {
                [key: string]: {
                    open: string[];
                    showAll: boolean;
                };
            }
        };
    },
    mounted() {},
    watch: {
        filterId() {
            //reset filter fields
            this.filterFieldStatus = {};
        },
        collections: {
            handler(newCollections: Collection[]) {
                if (this.portal) {
                    this.expandedCollectionIds = storeHelper.portalStore.getExpandedCollectionIDs(this.portal.portal_id);
                } else {
                    this.expandedCollectionIds = []; //collapse all
                }
            },
            immediate: true
        },
        expandedCollectionIds(newExpandedIds: number[], oldIds: number[]) {
            if (this.portal && JSON.stringify(newExpandedIds) !== JSON.stringify(oldIds))
                storeHelper.portalStore.setExpandedCollections(this.portal.portal_id, newExpandedIds);
        },
        showFilterPanelProp(newVal: boolean) {
            this.showFilterPanel = newVal;
        },
        showFilterPanel(newVal: boolean) {
            if (newVal === false) {
                this.$emit("close-nav-filter");
            }
        }
    },
    computed: {
        mdAndDown(): boolean {
            return this.$vuetify.breakpoint.mdAndDown;
        },
        lgAndUp(): boolean {
            return this.$vuetify.breakpoint.lgAndUp;
        },
        filterId(): string {
            return storeHelper.contentItemFiltersStore.filterId;
        },
        filterFields(): ContentItemFilterField[] {
            let filterFields = storeHelper.contentItemFiltersStore.filterFields;
            const activeOptions = storeHelper.contentItemFiltersStore.activeFilters;

            if (filterFields) {
                //remove field states for fields that don't exist
                for (const key in this.filterFieldStatus) {
                    //field still available
                    const field = filterFields.find(f => f.filter_field_id == key);
                    if (!field) {
                        delete this.filterFieldStatus[key];
                    }
                }

                filterFields.forEach(f => {
                    //no options?
                    if (f.filter_field_options == null) {
                        //is this an active filter?
                        if (activeOptions[f.filter_field_id]?.length > 0) {
                            //set the active option as option
                            f.filter_field_options = activeOptions[f.filter_field_id];
                        } else {
                            f.filter_field_options = [];
                        }
                    }

                    //create missing field states
                    if (!this.filterFieldStatus[f.filter_field_id]) {
                        this.filterFieldStatus[f.filter_field_id] = {
                            open: [],
                            showAll: false
                        };
                    }
                });

                filterFields = filterFields.filter(field => field.filter_field_options.length > 0);
                if (this.collections) {
                    //collections are given, exclude the collections filter field
                    return filterFields.filter(field => field.filter_field_id != SystemFilters.Collections);
                } else {
                    return filterFields;
                }
            }
            return filterFields;
        },
        scopeOptions(): { text: string | VueI18n.TranslateResult; scope: SearchScope; disabled: boolean; id: string }[] {
            return [
                {
                    text: this.$t("portal.labels.searchIn", { currentPortalNameParam: this.portal?.name }),
                    scope: "portal",
                    disabled: this.currentPortalDisabled,
                    id: "rdoScopeCurrentPortal"
                },
                {
                    text: this.$t("portal.labels.searchInAllPortals"),
                    scope: "global",
                    disabled: false,
                    id: "rdoScopeAllPortals"
                }
            ];
        },
        filterFieldOptionsLimit(): number {
            return this.mdAndDown ? 4 : 7;
        },
        collectionsTree(): Collection[] {
            const allContentOption: Collection = {
                collection_id: Constants.Collection.AllCollectionsId,
                name: this.$t("collections.completeContent").toString(),
                children: [],
                parent_collection_id: null,
                expanded: false,
                selected: false,
                order: 0
            };
            const data = [allContentOption];
            data.push(...this.collections);
            return data;
        },
        isIE11(): boolean {
            return Utils.isIE11;
        }
    },
    methods: {
        onScopeChange(newScope: SearchScope) {
            this.$emit("update:scope", newScope);
        },
        updateCollectionSelection(collectionIds: number[]) {
            //prevent setting selection to nothing
            if (collectionIds.length == 0) {
                this.$emit("update:selectedCollectionId", Constants.Collection.AllCollectionsId);
            } else {
                this.$emit("update:selectedCollectionId", collectionIds[0]);
            }
        },
        getActiveFilterFieldOptionIds(field: ContentItemFilterField): string[] {
            const activeOptions = storeHelper.contentItemFiltersStore.activeFilters[field.filter_field_id];
            if (activeOptions != null) {
                //prepend option id with field ID to make ids unique
                return activeOptions.map(option => `${field.filter_field_id}_${option.filter_field_option_id}`);
            } else {
                return [];
            }
        },
        getOpenFilterFieldOptionIds(field: ContentItemFilterField): string[] {
            let openItemIDs: string[];

            if (this.filterFieldStatus[field.filter_field_id]) {
                //prepend option id with field ID to make ids unique
                openItemIDs = this.filterFieldStatus[field.filter_field_id].open.map(id => `${field.filter_field_id}_${id}`);
            } else {
                openItemIDs = [];
            }

            //also open the parents of active items
            const activeOptions = storeHelper.contentItemFiltersStore.activeFilters[field.filter_field_id];
            if (activeOptions) {
                //find the parents of the options
                activeOptions.forEach(opt => {
                    openItemIDs.push(...opt.parentTreecode.map(id => `${field.filter_field_id}_${id}`));
                });
            }

            return openItemIDs;
        },
        setOpenFilterFieldOptions(field: ContentItemFilterField, tree_option_ids: string[]): void {
            //remove the prepended field id
            if (tree_option_ids) {
                this.filterFieldStatus[field.filter_field_id].open = tree_option_ids.map(id => id.split("_", 2)[1]);
            } else {
                this.filterFieldStatus[field.filter_field_id].open = [];
            }
        },

        showAllFilterFieldOptions(filterField: ContentItemFilterField) {
            this.filterFieldStatus[filterField.filter_field_id].showAll = true;
            this.$forceUpdate(); //?? WHY
        },
        getFilterFieldOptions(filterField: ContentItemFilterField): FilterFieldTreeViewOption[] {
            if (filterField.filter_field_options.length > 0) {
                const activeOptions = storeHelper.contentItemFiltersStore.activeFilters[filterField.filter_field_id];
                const activeOptionParents = activeOptions?.flatMap(opt => opt.parentTreecode) || [];

                let filterFieldOptions = filterField.filter_field_options;

                //show all or only a few options
                if (!this.filterFieldStatus[filterField.filter_field_id]?.showAll) {
                    filterFieldOptions = filterFieldOptions.slice(0, this.filterFieldOptionsLimit);
                }

                return filterFieldOptions
                    .filter(option => option.number_of_results > 0)
                    .map(opt => {
                        {
                            return {
                                treeItemId: `${filterField.filter_field_id}_${opt.filter_field_option_id}`,
                                filter_field_option_id: opt.filter_field_option_id,
                                name: opt.name,
                                number_of_results: opt.number_of_results,
                                options: opt.options
                                    ? this.getFilterOptionChildOptions(
                                          filterField.filter_field_id,
                                          opt,
                                          [opt.filter_field_option_id],
                                          activeOptionParents
                                      )
                                    : [],
                                parentId: filterField.filter_field_id,
                                parentTreecode: [],
                                hasActiveChild: activeOptionParents.includes(opt.filter_field_option_id)
                            } as FilterFieldTreeViewOption;
                        }
                    });
            }
        },
        getFilterOptionChildOptions(
            filter_field_id: string,
            filterOption: ContentItemFilterFieldOption,
            treecode: string[],
            activeOptionParents: string[]
        ): FilterFieldTreeViewOption[] {
            if (filterOption.options) {
                return filterOption.options
                    .filter(option => option.number_of_results > 0)
                    .map(opt => {
                        return {
                            treeItemId: `${filter_field_id}_${opt.filter_field_option_id}`,
                            filter_field_option_id: opt.filter_field_option_id,
                            name: opt.name,
                            number_of_results: opt.number_of_results,
                            options: opt.options
                                ? this.getFilterOptionChildOptions(
                                      filter_field_id,
                                      opt,
                                      [...treecode, opt.filter_field_option_id],
                                      activeOptionParents
                                  )
                                : [],
                            parentId: `${filter_field_id}_${filterOption.filter_field_option_id}`,
                            parentTreecode: treecode,
                            hasActiveChild: activeOptionParents.includes(opt.filter_field_option_id)
                        } as FilterFieldTreeViewOption;
                    });
            }
        },

        async activateFilterFieldOption(filterField: ContentItemFilterField, filterOption: FilterFieldTreeViewOption, event: Event) {
            //event.preventDefault();
            event.stopPropagation();

            //post activated filter option
            var response = await storeHelper.contentItemFiltersStore.postFilterFieldAsync(filterField.filter_field_id, filterOption);

            if (response) {
                this.$emit("filter-changed");
            }
        },
        async deactivateFilterFieldOption(filterField: ContentItemFilterField) {
            var response = await storeHelper.contentItemFiltersStore.deleteFilterFieldAsync(filterField.filter_field_id);
            if (response) {
                this.$emit("filter-changed");

                //Reset the active and open items set
                this.filterFieldStatus[filterField.filter_field_id].open = [];
            }
        }
    }
});
